<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    this.$Spin.show();
    if (localStorage.getItem('state')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(localStorage.getItem('state'))
        )
      );
    }
  }
};
</script>

<style lang="less">
.holamundo .vs-popup {
  width: 550px !important;
}

.ivu-tabs-nav {
  padding: 8px 16px;
}

.modal {
  .ivu-drawer-body {
    padding: 0;
  }

  .vs-sidebar {
    min-width: 438px !important;
  }

  .vs-sidebar--items {
    padding: 0;
  }
}

.vs-con-loading__container {
  position: relative;
}

.text-l {
  text-align: left;
}

.vs-pagination--mb {
  justify-content: center !important;
}

.dialog-title,
.vs-popup--title {
  font-weight: 300 !important;
}

.vs-con-textarea h4 {
  font-weight: lighter;
}

.vs-tabs--li button.vs-tabs--btn {
  padding: 10px 25px !important;
}

.text-hide {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}

.vs-popup--header {
  height: 62px;

  .vs-popup--title h3 {
    font-size: 18px;
    font-weight: 500 !important;
    color: #1f2329;
    line-height: 25px;
  }
}

.text-left {
  text-align: left;
}

.cur-p {
  cursor: pointer;
}

.vs-navbar__line {
  background: #39aba7 !important;
}

body {
  margin: 0;
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;
  height: auto;
  background: #f5f7fa;
}

html {
  overflow: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f5f7fa;
}
</style>
